import { useEffect } from "react";

export const useEventListener = (event = "", action, props = [], bubble) => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    document.addEventListener(event, action, bubble);
    return () => document.removeEventListener(event, action, bubble);
  }, props);
};
